import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  component: {
    id: 'alArcCodesForm.component',
    defaultMessage: 'Komponentti (ARC-vikakoodi)',
  },
  description: {
    id: 'alArcCodesForm.description',
    defaultMessage: 'Vian kuvaus (ARC-vikakoodi)',
  },
  loadingComponents: {
    id: 'alArcCodesForm.loadingComponents',
    defaultMessage: 'Ladataan ARC-komponentteja',
  },
  loadingDescriptions: {
    id: 'alArcCodesForm.loadingDescriptions',
    defaultMessage: 'Ladataan ARC-vikakoodeja',
  },
  retry: {
    id: 'alArcCodesForm.retry',
    defaultMessage: 'Hae ARC-koodit uudestaan',
  },
})
